import { mdiCheckCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import Button from "components/Button";
import Modal from "components/Modal";

interface IProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  title: string;
  content: string | React.ReactNode;
  backdropClick: () => void;
  isError?: boolean;
}

export default function StatusModal({
  isModalOpen,
  toggleModal,
  title,
  content,
  backdropClick,
  isError = false
}: Readonly<IProps>) {
  return (
    <Modal
      isOpen={isModalOpen}
      closeModal={toggleModal}
      wrapperClass="!my-auto desktop:!min-h-fit"
      dialogClass="!bg-foreground !opacity-95 !p-4 gap-4"
      closeClass="!top-24 !right-6 !bg-transparent !text-placeholder">
      <div
        className={clsx("flex gap-1 text-xl font-bold", isError ? "text-error" : "text-success")}>
        <Icon path={mdiCheckCircleOutline} />
        <span>{title}</span>
      </div>
      <span className="px-1 pb-2 text-text">{content}</span>
      <Button onClick={backdropClick} className="self-end w-20 rounded-full h-9">
        Ok
      </Button>
    </Modal>
  );
}
